/* Wires the seal loader into the two loading states this theme actually has.
 *
 * wcc.js is minified and ships from the theme, so it is not patched. Instead:
 *   1. add to cart  it replaces the button label with an empty
 *      <span class="wcc-spin"></span>. A MutationObserver fills that span with
 *      the glass loader. wcc-loader.css kills the rotation it also injects.
 *   2. collection grid  it sets #CollGrid style opacity to .4 while refetching
 *      and gives no other signal, so an attribute observer on that style
 *      toggles a centred overlay.
 *
 * Pagination and search have no async handlers in this theme, so there is
 * nothing to hook. That is a real gap, not an omission here.
 *
 * Loaders are cloned from <template> markup rendered by snippets/wcc-loader.
 * Every clone gets its defs ids rewritten, because two instances sharing a
 * mask id makes the later one render blank.
 */
(function () {
  'use strict';
  var tpl = document.getElementById('wcc-loader-tpl');
  if (!tpl) return;
  var seq = 0;

  function clone(kind) {
    var src = tpl.content.querySelector('[data-wcc-variant="' + kind + '"]');
    if (!src) return null;
    var el = src.cloneNode(true);
    seq++;
    var ids = el.querySelectorAll('[id]');
    for (var i = 0; i < ids.length; i++) {
      var was = ids[i].getAttribute('id');
      var now = was + '-c' + seq;
      ids[i].setAttribute('id', now);
      var users = el.querySelectorAll('[mask],[fill],[clip-path],[filter]');
      for (var j = 0; j < users.length; j++) {
        var attrs = ['mask', 'fill', 'clip-path', 'filter'];
        for (var k = 0; k < attrs.length; k++) {
          var val = users[j].getAttribute(attrs[k]);
          if (val && val.indexOf('#' + was + ')') !== -1) {
            users[j].setAttribute(attrs[k], val.split('#' + was + ')').join('#' + now + ')'));
          }
        }
      }
    }
    return el;
  }

  // ---- 1. add to cart ----------------------------------------------------
  function dress(span) {
    if (!span || span.getAttribute('data-wcc-done')) return;
    span.setAttribute('data-wcc-done', '1');
    var el = clone('glass');
    if (el) span.appendChild(el);
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.classList && node.classList.contains('wcc-spin')) dress(node);
    if (node.querySelectorAll) {
      var found = node.querySelectorAll('.wcc-spin');
      for (var i = 0; i < found.length; i++) dress(found[i]);
    }
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) scan(muts[i].addedNodes[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  var existing = document.querySelectorAll('.wcc-spin');
  for (var i = 0; i < existing.length; i++) dress(existing[i]);

  // ---- 2. collection grid ------------------------------------------------
  var grid = document.getElementById('CollGrid');
  if (!grid) return;
  var host = grid.parentNode;
  if (!host) return;
  host.classList.add('wcc-grid-host');

  var veil = document.createElement('div');
  veil.className = 'wcc-grid-veil';
  veil.setAttribute('aria-hidden', 'true');
  var big = clone('seal');
  if (big) veil.appendChild(big);
  host.appendChild(veil);

  function sync() {
    var dim = parseFloat(grid.style.opacity || '1') < 0.9;
    veil.classList.toggle('on', dim);
    grid.setAttribute('aria-busy', dim ? 'true' : 'false');
  }
  new MutationObserver(sync).observe(grid, { attributes: true, attributeFilter: ['style'] });
  sync();
})();
